import { Box, Typography } from '@mui/material';
import { MRT_ColumnDef } from 'mantine-react-table';
import React, { useMemo } from 'react';
import { RsvpSentStatsPoint } from '../../../../types/dashboard';
import GenericTable from '../../../../shared/GenericTable';
import { dashboardSummaryTableDefaults } from '../../dashboardReportTableConfig';

type RsvpsSentReportListProps = {
    points: RsvpSentStatsPoint[];
};

type SummaryRow = RsvpSentStatsPoint & { id: number };

export default function RsvpsSentReportList({
    points,
}: RsvpsSentReportListProps) {
    const columns: MRT_ColumnDef<SummaryRow>[] = useMemo(
        () => [
            {
                accessorKey: 'label',
                header: 'Period',
                size: 180,
            },
            {
                accessorKey: 'sentCount',
                header: 'RSVPs Sent',
                size: 150,
            },
            {
                accessorKey: 'notSentCount',
                header: 'Not Sent',
                size: 150,
            },
        ],
        [],
    );

    const rows = useMemo(
        () =>
            (points ?? []).map((point, index) => ({
                id: index + 1,
                ...point,
            })),
        [points],
    );

    if (!rows.length) {
        return (
            <Typography sx={{ mt: 4 }} variant='body2'>
                No guest bookings found for this selection.
            </Typography>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <GenericTable
                {...dashboardSummaryTableDefaults}
                columns={columns}
                data={rows}
                tableName='RSVPs Sent Summary'
            />
        </Box>
    );
}
